import type { CriteriasType, TemplateType } from 'store/search/search.types';
import type { ValueObj } from 'utils/optionsCreator';
import type { OptionType } from '../Selects/MultiValueSelect/multiValuesSelect';
import type { Logic } from '../Selects/MultiValueSelect/components/MultiSelectWithConditions/MultiSelectWithConditions';

export enum Page {
	Calls = 'calls',
	Reports = 'reports',
	ReportsBlock = 'reports_block',
	Markup = 'markup',
	Checklists = 'checklists',
	CallsFromReportCell = 'callsFromReportCell',
	Deals = 'deals',
	Gpt = 'gpt',
} // страницы, где используется CriteriaItem / CriteriaWithConditions

export type SortedCriteriasListType = {
	blockNumber: number;
	criterias: CriteriasType[];
	complexCriterias: Record<string, CriteriasType[]>;
	// complexCriterias: CriteriasType[];
};

export type HandlerOnChange = (event: any, criteria: CriteriasType, logic?: Logic) => void;

export type OnAddCondition = (data: CriteriasType, page: string, index: number) => void;

export type CustomValueHandler = (
	values: OptionType[],
	itemLogic?: Logic | undefined,
	itemId?: number | undefined,
) => void;

export interface FindCriteriasPropsType {
	allCriterias: CriteriasType[] | null;
	activeCriterias: CriteriasType[];
	block?: string;
	handlerOnChange?: HandlerOnChange;
	isHandlerFunction?: boolean;
	page: Page;
	// простой список в строчку (например, в отчетах "точный фильтр")
	simpleList?: boolean;
	// список в колонку с названиями (например, в чек-листах)
	simpleListWithTitles?: boolean;
	// индекс добавленного столбца в параметрах отчета
	reportBlockIndex?: number;
	// функция, вызывающаяся при добавлении/удалении логического условия
	onAddCondition?: OnAddCondition;
	onDeleteCondition?: OnAddCondition;

	// доп свойства для заголовков
	blockTitle?: string;
	titleTooltip?: string;
	onTemplateSelectValueChange?: (event: any) => void;
	convertedTemplate?: {
		value: any;
		label: string;
	}[];
	currentTemplate?: TemplateType | null;
	allTemplates?: TemplateType[];
	onClearTemplateClick?: () => void;
	hideParametersBlock?: boolean;
}

export interface ICriteriaItem {
	criteriaFull: CriteriasType;
	criteriaCurrent: CriteriasType;
	page: Page;
	isHandlerFunction?: boolean | undefined;
	handlerOnChange?: HandlerOnChange;
	block?: Page;
	title?: string;
	className?: string;
	conditionItemId?: number;
	hasConditions?: boolean;
	logic?: Logic;
	customValueHandler?: CustomValueHandler;
}

export interface CriteriaWithConditionsProps {
	criteriaKey: string;
	data: CriteriasType[];
	allCriterias: CriteriasType[];
	block?: Page;
	index: number;
	handlerOnChange?: HandlerOnChange;
	isHandlerFunction?: boolean | undefined;
	page: Page;
	onAddCondition?: OnAddCondition;
	onDeleteCondition?: OnAddCondition;
	customValueHandler?: CustomValueHandler;
	title?: string;
}

export interface ICriteriaConditions {
	criteriaItems: CriteriasType[];
	allCriterias: CriteriasType[];
	isSingleCondition: boolean;
	handlerOnChange?: HandlerOnChange;
	isHandlerFunction?: boolean | undefined;
	handleDelete: (item: CriteriasType) => void;
	page: Page;
	block?: Page;
	customValueHandler?: CustomValueHandler;
}

export interface ICriteriaListSimple {
	allCriterias: CriteriasType[];
	otherCriteria: CriteriasType[];
	complexCriteria: CriteriasType[];
	block?: Page;
	handlerOnChange?: HandlerOnChange;
	isHandlerFunction?: boolean;
	page: Page;
	onAddCondition?: OnAddCondition;
	onDeleteCondition?: OnAddCondition;
}

export interface ConvertedTemplateOption {
	value: string | TemplateType;
	label: string;
}

export interface ICriteriaHeader {
	// доп свойства для заголовков
	blockTitle?: string;
	titleTooltip?: string;
	onTemplateSelectValueChange?: (value: ValueObj) => void;
	convertedTemplate?: ConvertedTemplateOption[];
	currentTemplate?: TemplateType | null;
	allTemplates?: TemplateType[];
	onClearTemplateClick?: () => void;
}
export interface ICriteriaMultiList extends ICriteriaHeader {
	activeCriterias: CriteriasType[];
	allCriterias: CriteriasType[];
	sortedCriterias: SortedCriteriasListType[];
	block?: Page;
	handlerOnChange?: HandlerOnChange;
	isHandlerFunction?: boolean;
	page: Page;
	onAddCondition?: OnAddCondition;
	onDeleteCondition?: OnAddCondition;
	simpleListWithTitles?: boolean;
	hideParametersBlock?: boolean;
}

export interface CriteriasTopHeaderProps extends ICriteriaHeader {
	classes: Record<string, string>;
	language: string;
	simpleListWithTitles: boolean | undefined;
	hideParametersBlock?: boolean;
}
